module.exports = __webpack_public_path__ + "img/WeatherStation.b00d9651.png";